import React from "react";
import { useTranslation } from "react-i18next";
import "./TechCard.css";

/**
 * Renders a product card: icon + title, "What is X?", description, "Key Features:", 5 bullets.
 * Keys are under what.* with prefix (e.g. seedSigner → what.seedSignerTitle, what.seedSignerWhat, ...).
 */
function TechCard({ icon, prefix }) {
  const { t } = useTranslation();
  const featureKeys = [1, 2, 3, 4, 5].map((i) => `what.${prefix}Feature${i}`);

  return (
    <section className="what-section">
      <h2>{icon} {t(`what.${prefix}Title`)}</h2>
      <div className="tech-card">
        <h3>{t(`what.${prefix}What`)}</h3>
        <p>{t(`what.${prefix}Desc`)}</p>
        <h4>{t(`what.${prefix}Features`)}</h4>
        <ul>
          {featureKeys.map((key) => (
            <li key={key}>
              <strong>{t(key)}</strong>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default TechCard;
